import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

const smartphoneIcon = css`
  && {
    margin-right: 10px;
    height: 16px;
    width: 16px;
  }
`;

const smartphoneIconWithCustomColor = css`
  ${smartphoneIcon}
  color: ${colors.gray[10]};
`;

const checkIcon = css`
  margin-left: 5px;
  color: ${colors.success[9]};
`;

const driverCodeCell = css`
  display: flex;
  flex-direction: row;
  align-text: center;
  align-items: center;
`;

export default {
  smartphoneIconWithCustomColor,
  checkIcon,
  driverCodeCell,
};
